import React from 'react';
import { ReactComponent as LinkIcon } from './../assets/link-icon.svg';
import Link from './link/Link';
import './PortfolioLinks.css';

const PortfolioLinks = ({ name, values, errors, touched }) => {
    return (
        <div className="field-wrap portfolio">
            <div className="field-header">
                <LinkIcon />
                <div className="header-text">Portfolio</div>
            </div>
            <div className="field-subHeader portfolioLinks">
                Depending on the brief you may be asked to include your portfolio.
            </div>
            <ul className="links-list">
                {values[name].map((link, i) => (
                    <Link
                        key={link.name}
                        link={link}
                        i={i}
                        errors={errors}
                        touched={touched}
                        name={name}
                    />
                ))}
            </ul>
        </div>
    );
};

export default PortfolioLinks;
